import { render, staticRenderFns } from "./VideoUploadEdition.vue?vue&type=template&id=700c9642&scoped=true&"
import script from "./VideoUploadEdition.vue?vue&type=script&lang=js&"
export * from "./VideoUploadEdition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c9642",
  null
  
)

export default component.exports